import {ReportVTagCommunicationModel} from "../../models/reports/ReportVTagCommunicationModel";

export class ReportVTagCommunicationCtrl {
    public static $inject = ['$scope','ReportVTagCommunicationModel'];
    constructor(public $scope:any, public model:ReportVTagCommunicationModel) {
        $scope.vm = this;
        this.$scope.$watch(() => [this.model.vtagType, this.model.daysToReport],(newValue: string, oldValue: string) => {
            this.model.getCount();
        },true);
    }
}
